import _ from 'lodash';
import React, {Component, PropTypes} from 'react';
import { readComponentInstanceResourceList } from '../../lib/frankly';
import ComponentTitle from '../shared/ComponentTitle';
import ComponentLoader from '../../../shared/utils/ComponentLoader';
import Pagination from 'components/icons/Pagination';
import * as domutils from '../../utils/DOMUtils';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

class TabbedCategoryHeadlines extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    barBackgroundColor: PropTypes.string,
    barTextColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    activeTabBackgroundColor: PropTypes.string,
    tabbedLineColor: PropTypes.string,
    articleListType: PropTypes.string.isRequired,
    tabs: React.PropTypes.arrayOf(
      React.PropTypes.shape({
        title: PropTypes.string.isRequired
      }).isRequired
    ).isRequired,
    titleType: PropTypes.string
  };

  static defaultProps = {
    barBackgroundColor: '#000',
    barTextColor: '#FFF',
    backgroundColor: '#FFF',
    activeTabBackgroundColor: '#3498db',
    tabbedLineColor: '',
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  constructor(props) {
    super(props);
    this.headerDomObject = null;
    this.paginationDomObject = null;
    this.tabDomObjects = [];
    this.showPager = false;
  }

  state = {
    tabsRawResponses: this.props.FRN_rawResponses && this.props.FRN_rawResponses.length > 0 ? [this.props.FRN_rawResponses] : [],
    ComponentClass: null,
    activeTabIndex: this.props.FRN_rawResponses && this.props.FRN_rawResponses.length > 0 ? 0 : -1,
    hoverTabIndex: this.props.FRN_rawResponses && this.props.FRN_rawResponses.length > 0 ? 0 : -1,
    totalHiddenTabCount: 0,
    shiftLeftValue: 0,
  };

  componentWillMount() {
    ComponentLoader.importReactComponent(this.props.articleListType).then(ComponentClass =>
      this.setState({ ComponentClass })
    ).catch(error => {
        throw new Error(error);
      }
    );
  }

  componentDidMount() {
    this.showPager = domutils.isOverflow(this.headerDomObject);
    this._initData();
  }

  _initData() {
    const {activeTabIndex, tabsRawResponses} = this.state;
    if (activeTabIndex < 0) {
      let index = 0;
      if (!tabsRawResponses[index]) {
        const { tabs } = this.props;
        const tab = tabs[index];

        if (tab && tab.FRN_resourceEndpoints) {
          readComponentInstanceResourceList(this, { propPath: `tabs[${index}]` }).then(rawResponse => {
            tabsRawResponses[index] = rawResponse;
            this.setState({ 
              tabsRawResponses,
              activeTabIndex: index,
              hoverTabIndex: index
            });
          });
        }
      }
    }
  }

  _getHeaderWidth() {
    return this.headerDomObject.clientWidth;
  }

  _handleTabChange(index) {
    const {
      tabsRawResponses,
      activeTabIndex
    } = this.state;

    if (index !== activeTabIndex) {
      if (!tabsRawResponses[index]) {
        const { tabs } = this.props;
        const tab = tabs[index];

        if (tab && tab.FRN_resourceEndpoints) {
          readComponentInstanceResourceList(this, { propPath: `tabs[${index}]` }).then(rawResponse => {
            tabsRawResponses[index] = rawResponse;
            this.setState({ tabsRawResponses });
          });
        }
      }

      this.setState({activeTabIndex: index});
    }
  }

  _onNext() {
    const { tabs } = this.props;
    const { totalHiddenTabCount, shiftLeftValue } = this.state;
    const visibleHeaderWidth = this._getHeaderWidth() - this.paginationDomObject.clientWidth;
    const tabContainerWidth = this.tabContainer.clientWidth;

    if (shiftLeftValue + visibleHeaderWidth < tabContainerWidth && totalHiddenTabCount < tabs.length) {
      const tabWidthToShiftLeft = this.tabDomObjects[totalHiddenTabCount].clientWidth;

      this.setState({
        totalHiddenTabCount: totalHiddenTabCount + 1,
        shiftLeftValue: shiftLeftValue + tabWidthToShiftLeft
      });
    }
  }

  _onBack() {
    const { totalHiddenTabCount, shiftLeftValue } = this.state;

    if (totalHiddenTabCount) {
      const tabWidthToShiftRight = this.tabDomObjects[totalHiddenTabCount - 1].clientWidth;

      this.setState({
        totalHiddenTabCount: totalHiddenTabCount - 1,
        shiftLeftValue: shiftLeftValue - tabWidthToShiftRight
      });
    }
  }

  _toggleHover(index) {
    this.setState({hoverTabIndex: index});
  }

  render() {
    if (this.state.activeTabIndex < 0) {
      return (
        <div className="TabbedCategoryHeadlines" style={{backgroundColor}}>
          {title ? <ComponentTitle titleType={titleType} title={title} color={titleColor}/> : null}
          <div className="TabbedCategoryHeadlines-header"
              ref={(div) => this.headerDomObject = div}
              style={headerStyles}>
          </div>
        </div>
      );
    }

    const {
      title,
      barBackgroundColor,
      barTextColor,
      backgroundColor,
      activeTabBackgroundColor,
      tabbedLineColor,
      tabs,
      titleColor,
      titleType
    } = this.props;

    const {
      tabsRawResponses,
      ComponentClass,
      activeTabIndex,
      hoverTabIndex,
      shiftLeftValue
    } = this.state;

    const { props: activeTabData } = tabs[activeTabIndex];

    activeTabData['FRN_rawResponses'] = tabsRawResponses[activeTabIndex] || [];

    const headerStyles = {
      backgroundColor: barBackgroundColor
    };
    const titleStyles = {
      color: barTextColor
    };
    const shiftLeftStyles = {
      transform: `translateX(-${shiftLeftValue}px)`
    };

    return (
      <div className="TabbedCategoryHeadlines" style={{backgroundColor}}>
        {title ? <ComponentTitle titleType={titleType} title={title} color={titleColor}/> : null}
        <div className="TabbedCategoryHeadlines-header"
             ref={(div) => this.headerDomObject = div}
             style={headerStyles}>
          <div className="TabbedCategoryHeadlines-tabContainer"
               ref={(div) => this.tabContainer = div}
               style={{...shiftLeftStyles}}>
            {
              _.map(tabs, (tab, index) => {
                const tabBackgroundColor = {
                  backgroundColor: (index === activeTabIndex) || (index === hoverTabIndex) ? activeTabBackgroundColor : null
                };

                const tabbedLineStyles = {
                  borderRight: tabbedLineColor && index < tabs.length - 1 ? `1px solid ${tabbedLineColor}` : null
                };

                return (
                  <h1 key={index}
                    style={{...titleStyles, ...tabBackgroundColor, ...tabbedLineStyles}}
                    onClick={() => this._handleTabChange(index)}
                    ref={(currentTab) => this.tabDomObjects[index] = currentTab}
                    onMouseEnter={() => this._toggleHover(index)}
                    onMouseLeave={() => this._toggleHover(-1)}>
                    {tabs[index].title}
                  </h1>);
              })
            }
          </div>
          {
            this.showPager ? <div className="TabbedCategoryHeadlines-header-paginationControls"
                        ref={(div) => this.paginationDomObject = div}
                        style={{backgroundColor: activeTabBackgroundColor}}>
                          <button onClick={() => this._onBack()}>
                            <Pagination direction="left" color={barTextColor}/>
                          </button>
                          <button onClick={() => this._onNext()}>
                            <Pagination direction="right" color={barTextColor}/>
                          </button>
                        </div> : null
          }
        </div>
        <section className="TabbedCategoryHeadlines-section" style={{backgroundColor}}>
            {ComponentClass && <ComponentClass key={activeTabIndex} {...activeTabData} />}
          </section>
      </div>
    );
  }
}

export default TabbedCategoryHeadlines;



// WEBPACK FOOTER //
// ./app/components/news/TabbedCategoryHeadlines.js